export const  create_group = "groups/creategroup"
export const  fetch_group = "groups"
export const  generate_random = "groups/generate-id"
export const  upload_file = "files/uploadFIle"
export const  create_company = "/companies/createcompany"
export const  comp_id = "/companies/generate-id"
export const  delete_company = "/companies"
export const  delete_group = "/groups"